export default "__VITE_ASSET__Dhz1pJUT__"